import { render, staticRenderFns } from "./ChangeNumber.vue?vue&type=template&id=72351c76"
import script from "./ChangeNumber.vue?vue&type=script&lang=js"
export * from "./ChangeNumber.vue?vue&type=script&lang=js"
import style0 from "./ChangeNumber.vue?vue&type=style&index=0&id=72351c76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports